import React from 'react';
import { RoutePermittedRole } from '@crema/constants/AppEnums';

const HolidayInfo = React.lazy(() => import('../../modules/holidayMgmt'));
const HolidayList = React.lazy(() => import('../../modules/holidayMgmt/list'));
const HolidayRegistration = React.lazy(() => import('../../modules/holidayMgmt/registration'));
const DeliveryManagement = React.lazy(() => import('../../modules/deliveryManagement'));
const ApiInfo = React.lazy(() => import('../../modules/apiInformation'));

export const channelProductConfigs = [
  {
    permittedRole: RoutePermittedRole.User,
    path: '/holidayInfo',
    element: <HolidayInfo />,
    children: [
      {
        path: '',
        element: <HolidayList />,
      },
      {
        path: 'registration',
        element: <HolidayRegistration />,
      },
    ],
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/apiInfo',
    element: <ApiInfo />,
    children: [
      {
        path: '',
        element: <ApiInfo />,
      },
    ],
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: '/deliveryInfo',
    element: <DeliveryManagement />,
  },
];
